// 件名の差し込み変数（{{lastname}} やカスタム項目の {{項目名}} など）
const VARIABLE_PATTERN = /{{[^{}]*}}/g;

// 件名が空のメールは SendGrid に拒否されて届かない。
// 件名が変数だけだと、変数の値が空の宛先で件名が空になるため、変数以外の文字も必須にする。
// サーバー側の MailCampaign#invalid_message_for_subject と同じ判定 #17226
const mailSubjectError = (subject?: string | null): string | null => {
  if (!subject?.trim()) return '必須項目です';
  if (!subject.replace(VARIABLE_PATTERN, '').trim()) {
    return '件名には変数以外の文字も入れてください';
  }
  return null;
};

export default mailSubjectError;
